/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import { AppContext } from 'domains/commons/contexts/global/global-provider';
import { useFetchModels } from 'domains/core-base/vehicle/hooks/queries/use-fetch-models';
import { useFetchSumInsured } from 'domains/core-base/vehicle/hooks/queries/use-fetch-sum-insured';
import { useFetchBrands } from 'domains/core-base/vehicle/hooks/queries/use-fetch-brands';
import { IOption } from 'domains/quotation/constants/information';
import { useCreateVehicle } from 'domains/core-base/vehicle/hooks/mutations/use-create-vehicle';
import { usePatchVehicle } from 'domains/core-base/vehicle/hooks/mutations/use-patch-vehicle';
import { useGetChineseVehicle } from 'domains/core-base/vehicle/hooks/mutations/use-get-chinese-vehicle';
import { PROVINCES } from 'domains/quotation/constants/provinces';
import { DataLayer } from 'libs/providers/datalayer/datalayer';
import {
  globalFlow,
  VIRTUAL_EVENT_ACTIONS,
  VIRTUAL_EVENT_CATEGORIES,
  VIRTUAL_EVENT_SECTION,
  VIRTUAL_EVENT_SUB_ZONE,
  VIRTUAL_EVENT_TYPE_ELEMENT,
  VIRTUAL_EVENT_TYPE_EVENT,
  VIRTUAL_EVENT_TYPE_ZONE,
  VIRTUAL_EVENT_ZONE,
} from 'libs/providers/datalayer/constants';
import { useQuotationFull } from 'domains/core-base/quotation/hooks/mutations/use-quotation-full';
import {
  CHINESE_VEHICLE_ACTION,
  QUOTATION_ACTION,
  VEHICLE_ACTION,
} from 'domains/commons/contexts/global/staticData';
import { isPilotChannelLanding } from 'libs/utils/routes';

export const useModalVehicle = ({
  handleClose,
  isOpen,
  isEdit,
  fields,
  setField,
}: {
  handleClose: any;
  isOpen: boolean;
  isEdit: boolean;
  fields?: any;
  setField?: any;
}) => {
  const { store, actions } = useContext(AppContext);
  const quotationFullMutation = useQuotationFull();
  const [spinner, setSpinner] = useState(false);

  const carYears = +(import.meta.env.VITE_APP_CAR_YEARS ?? 0);

  const [error, setError] = useState(false);

  const [initValues, setInitValues] = useState({
    brandCode: '',
    modelCode: '',
    carYear: '',
  });

  const [fieldsVehicle, setFieldVehicle] = useState({
    brandCode: store.vehicle?.brand?.code ?? '',
    modelCode: store.vehicle?.model?.code ?? '',
    year: store.vehicle?.year ?? '',
    province: '',
  });

  const formValid = Object.entries(fields || fieldsVehicle)
    .filter(([key]) => (!store.dataLayer.hasPlate ? true : key !== 'province'))
    .every(([_, value]) => value);

  const { data: brands = [] } = useFetchBrands();
  const { data: models = [] } = useFetchModels({
    brandCode: fields ? fields.brandCode : fieldsVehicle.brandCode,
  });

  const { data: sumInsured } = useFetchSumInsured({
    data: {
      brandCode: fields ? fields.brandCode : fieldsVehicle.brandCode,
      apesegBrandCode: fields
        ? brands.find((item) => item.brandCode === fields.brandCode)
            ?.apesegBrandCode ?? ''
        : brands.find((item) => item.brandCode === fieldsVehicle.brandCode)
            ?.apesegBrandCode ?? '',
      modelCode: fields ? fields.modelCode : fieldsVehicle.modelCode,
      apesegModelCode: fields
        ? models.find((item) => item.modelo.code === fields.modelCode)?.modelo
            .apesegCode ?? ''
        : models.find((item) => item.modelo.code === fieldsVehicle.modelCode)
            ?.modelo.apesegCode ?? '',
      year: fields ? fields.year : fieldsVehicle.year,
    },
  });
  const [years, setYears] = useState<{ label: string; value: string }[]>([]);
  const vehicleCreate = useCreateVehicle();
  const vehicleUpdate = usePatchVehicle();
  const getChineseVehicleMutation = useGetChineseVehicle();
  const isAdvisorLanding = isPilotChannelLanding(window.location.pathname);

  const getYearsWithPlate = (year: string) => {
    const date = new Date();
    const currentYear = date.getFullYear();

    let yearsOfDifference = 0;
    let initialYear = 0;

    initialYear =
      year.length === 1
        ? parseInt(`200${year}`, 10)
        : parseInt(`20${year}`, 10);

    yearsOfDifference = currentYear - initialYear;

    return yearsOfDifference > 19 ? 19 : yearsOfDifference;
  };

  const getLastVehicleYears = () => {
    const yearsList = [];
    const { hasPlate } = store.dataLayer;
    const date = new Date();
    const futureYear = date.getFullYear() + carYears;
    const currentYear = hasPlate ? date.getFullYear() : futureYear;
    const yearsDifference = getYearsWithPlate(carYears.toString());

    for (
      let year = futureYear;
      year >= currentYear - yearsDifference;
      year -= 1
    ) {
      yearsList.push({ label: `${year}`, value: `${year}` });
    }

    return yearsList.sort((a, b) => (a.label < b.label ? 1 : -1));
  };

  const handleBrandChage = (item: IOption) => {
    if (setField) {
      setField((data: any) => ({
        ...data,
        brandCode: item.value,
        modelCode: '',
      }));
    } else {
      setFieldVehicle((data: any) => ({
        ...data,
        brandCode: item.value,
        modelCode: '',
      }));
    }
  };

  const hanldeOnChange = (val: any, field: any) => {
    if (setField) {
      setField({
        ...fields,
        [field]: val,
      });
    } else {
      setFieldVehicle({
        ...fieldsVehicle,
        [field]: val,
      });
    }
  };

  const closeModal = () => {
    DataLayer.setVirtualEvent({
      category: VIRTUAL_EVENT_CATEGORIES.default,
      action: VIRTUAL_EVENT_ACTIONS.principal,
      label: 'Modal - Datos del Vehículo - Cerrar',
      tipoZona: VIRTUAL_EVENT_TYPE_ZONE.autos,
      zona: VIRTUAL_EVENT_ZONE.nuevo,
      subZona: VIRTUAL_EVENT_SUB_ZONE.inicio,
      sección: VIRTUAL_EVENT_SECTION.modal,
      tipoEvento: VIRTUAL_EVENT_TYPE_EVENT.click,
      tipoElemento: VIRTUAL_EVENT_TYPE_ELEMENT.modalBoton,
      valor: ' Sobre tu vehículo:Cerrar',
      flujo: globalFlow(store.dataLayer),
    });

    handleClose(true);
  };

  const handleGetVehicleData = () => {
    const model = fields
      ? models.find((item) => item.modelo.code === fields.modelCode)
      : models.find((item) => item.modelo.code === fieldsVehicle.modelCode);
    const brand = fields
      ? brands.find((item) => item.brandCode === fields.brandCode)
      : brands.find((item) => item.brandCode === fieldsVehicle.brandCode);

    const vehicleData: any = {
      id: null,
      plate: store.vehicle?.plate || '',
      hasPlate: null,
      year: fields?.year || fieldsVehicle.year,
      vehicleType: model?.vehicleType,
      vehicleClass: model?.vehicleClass,
      riskType: model?.riskType,
      useType: 'auto',
      numberSeats: model?.numberOfDoors,
      engineSerialNumber: store.vehicle?.engineSerialNumber || '',
      chassisSerialNumber: store.vehicle?.chassisSerialNumber || '',
      brand: {
        code: brand?.brandCode,
        description: brand?.brandDescription,
        apesegCode: brand?.apesegBrandCode,
      },
      model: {
        code: model?.modelo.code,
        description: model?.modelo.description,
        apesegCode: model?.modelo.apesegCode,
        standard: model?.modelo.standard,
        mtcCategory: model?.modelo.mtcCategory,
        alternateModel: model?.modelo.alternative,
      },
      sumInsured: {
        estimated: sumInsured?.estimated,
        selected: sumInsured?.selected,
        max: sumInsured?.max,
        min: sumInsured?.min,
        exchangeRate: sumInsured?.exchangeRate,
      },
    };

    return vehicleData;
  };

  const handleBtnSave = async () => {
    const vehicleData: any = handleGetVehicleData();

    DataLayer.setVirtualEvent({
      category: VIRTUAL_EVENT_CATEGORIES.default,
      action: VIRTUAL_EVENT_ACTIONS.principal,
      label: 'Modal - Datos del Vehículo - Visualizar',
      tipoZona: VIRTUAL_EVENT_TYPE_ZONE.autos,
      zona: VIRTUAL_EVENT_ZONE.nuevo,
      subZona: VIRTUAL_EVENT_SUB_ZONE.inicio,
      sección: VIRTUAL_EVENT_SECTION.modal,
      tipoEvento: VIRTUAL_EVENT_TYPE_EVENT.click,
      tipoElemento: VIRTUAL_EVENT_TYPE_ELEMENT.modalBoton,
      valor: ' Sobre tu vehículo:Guardar y Continuar',
      flujo: globalFlow(store.dataLayer),
      extra: {
        marcaVehiculo: vehicleData.brand.description,
        modeloVehiculo: vehicleData.model.description,
        anioVehiculo: vehicleData.year,
      },
    });

    if (!sumInsured?.estimated || !sumInsured?.max || !sumInsured?.min) {
      setError(true);
      return;
    }

    setSpinner(true);

    const newVehicle = await vehicleCreate.mutateAsync(vehicleData);
    const { vehicle } = store;

    vehicle.chassisSerialNumber =
      vehicle.chassisSerialNumber === 'S/D'
        ? null
        : vehicle.chassisSerialNumber;
    vehicle.engineSerialNumber =
      vehicle.engineSerialNumber === 'S/D' ? null : vehicle.engineSerialNumber;

    const vehicleInfo = await vehicleUpdate.mutateAsync({
      id: newVehicle.id,
      ...(vehicle?.chassisSerialNumber && {
        chassisSerialNumber: vehicle?.chassisSerialNumber,
      }),
      ...(vehicle?.engineSerialNumber && {
        engineSerialNumber: vehicle?.engineSerialNumber,
      }),
      sumInsuredSelected: sumInsured?.estimated,
    });

    actions.dispatchVehicle({
      type: VEHICLE_ACTION.set,
      payload: {
        ...vehicleData,
        id: newVehicle.id,
        location: fields?.province || fieldsVehicle.province,
        circulationAreaCode:
          fields?.province ||
          fieldsVehicle.province ||
          vehicle?.circulationAreaCode,
      },
    });

    if (isEdit && store.plan.offerCode && !isAdvisorLanding) {
      const quotation = await quotationFullMutation.mutateAsync({
        clientId: store.customer.id,
        requestId: store.request.id,
        vehicleId: vehicleInfo.id,
        offerCode: store.plan.offerCode,
        promotionalCode: '',
        typeOfQuote: 'full',
      });

      actions.dispatchQuotation({
        type: QUOTATION_ACTION.set,
        payload: quotation,
      });
    }

    const { vehicleEnable } = await getChineseVehicleMutation.mutateAsync({
      id: newVehicle.id,
    });

    actions.dispatchVehicleEnable({
      type: CHINESE_VEHICLE_ACTION.set,
      payload: vehicleEnable,
    });

    handleClose(false,newVehicle?.id);
    if (isAdvisorLanding && isEdit) setSpinner(false);
  };

  useEffect(() => {
    if (!isOpen) return;
    setYears(getLastVehicleYears());
    DataLayer.setVirtualEvent({
      category: VIRTUAL_EVENT_CATEGORIES.default,
      action: VIRTUAL_EVENT_ACTIONS.principal,
      label: 'Modal - Datos del Vehículo - Sobre tu vehículo',
      tipoZona: VIRTUAL_EVENT_TYPE_ZONE.autos,
      zona: VIRTUAL_EVENT_ZONE.nuevo,
      subZona: VIRTUAL_EVENT_SUB_ZONE.inicio,
      sección: VIRTUAL_EVENT_SECTION.modal,
      tipoElemento: VIRTUAL_EVENT_TYPE_ELEMENT.modal,
      tipoEvento: VIRTUAL_EVENT_TYPE_EVENT.visualizar,
      valor: 'Sobre tu vehículo',
      flujo: globalFlow(store.dataLayer),
    });
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    const brandCode = store.vehicle?.brand?.code ?? '';
    const modelCode = store.vehicle?.model?.code ?? '';
    const carYear = store.vehicle?.year ?? '';

    setInitValues({
      brandCode,
      modelCode,
      carYear,
    });
    if (setField) {
      setField({
        ...fields,
        brandCode,
        modelCode,
        year: carYear,
      });
    } else {
      setFieldVehicle({
        ...fields,
        brandCode,
        modelCode,
        year: carYear,
      });
    }
  }, [isOpen]);

  return {
    closeModal,
    hasPlate: store.vehicle?.hasPlate,
    provinces: PROVINCES.map((item) => ({
      label: item.name,
      value: item.value,
    })),
    brands: brands.map((item) => ({
      label: item.brandDescription,
      value: item.brandCode,
    })),
    models: models.map((item) => ({
      label: item.modelo.description,
      value: item.modelo.code,
    })),
    years,
    fields: fields || fieldsVehicle,
    handleBrandChage,
    hanldeOnChange,
    handleBtnSave,
    formValid,
    initValues,
    spinner,
    error,
    sumInsured,
  };
};
